export default __webpack_public_path__ + "static/media/sl.66d64d89.svg";